import { InjectionToken } from '@angular/core';

export { StorageService } from './storage.service';

export const STORAGE_INJECTION_KEY = new InjectionToken(
  'STORAGE_INJECTION_KEY'
);
